// import { HasPrivileges } from '@/components/HasPrivileges'
import { Separator } from '@/components/Separator'
import { Stack } from '@mui/material'

import { FilterOrders } from './components/FilterOrders'
// import { SwarmsToggle } from './components/SwarmsToggle'
import { FitAllToggle } from './components/FitAllToggle'
import { FreezeMapToggle } from './components/FreezeMapToggle'
import { GlobalStyles } from './components/GlobalStyles'
import { InspectPinToggle } from './components/InspectPinToggle'
import { Lasso } from './components/Lasso'
import { LiveTrafficToggle } from './components/LiveTrafficToggle'
import { MapTimeRange } from './components/MapTimeRange'

interface Props {
  disableInspectPin: boolean
  canFilterOrders: boolean
  disableLasso: boolean
}

export function Controls(props: Props) {
  const { disableInspectPin, canFilterOrders, disableLasso } = props

  return (
    <Stack direction="row" alignItems="center" height={26}>
      <MapTimeRange />

      <LiveTrafficToggle />

      <FreezeMapToggle />

      <InspectPinToggle disabled={disableInspectPin} />

      <Separator />

      {/*
        I leave the component here since it will be implemented in the future
        <HasPrivileges demo dev>
          <SwarmsToggle />
        </HasPrivileges> */}

      <Lasso disabled={disableLasso} />

      <FitAllToggle />

      <GlobalStyles />

      {canFilterOrders && <FilterOrders />}
    </Stack>
  )
}
